import styled from 'styled-components';

export const StyledLastAction = styled.div`
    position: relative;
    padding-inline-start: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:before {
        content: '';
        position: absolute;
        left: ${({ ltr }) => ltr ? 0 : ''};
        right: ${({ ltr }) => ltr ? '' : 0};
        top: 0;
        bottom: 0;
        width: 3px;
        background: ${({ expense }) => expense ? 'linear-gradient(25.89deg, #E632BE 16.34%, #F44197 83.66%)' : 'linear-gradient(25.89deg, #6A92FF 16.34%, #8764FF 83.66%)'};
        border-radius: 2px;
    }

    .action-info, .action-type {
        font-size: 14px;
        color: #373647;
        opacity: 0.7;
    }

    .action-type {
        font-weight: 700;
        font-size: 16px;
    }

    .arrow {
        width: 28px;
        height: 28px;
        background: #E9E9FD;
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transform: ${({ ltr }) => ltr ? 'rotate(180deg)' : ''};
    }
`